import { RECEIVE_DATA_OBJECTS, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type ILeadCompanyProfile, type IPrivateCompany } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { isDataObject } from '@/services/data-object-helper';

import { PRIVATE_COMPANY_MODULE } from '../private-company-module';

export const actions: ActionTree<ILeadCompanyProfile, unknown> = {
    [STORE_DATA_OBJECTS](context, { dataObjectList }: { dataObjectList: ILeadCompanyProfile[] }) {
        const assetProfiles: ILeadCompanyProfile[] = [];
        const assetEntities: IPrivateCompany[] = [];

        dataObjectList.forEach((assetProfile) => {
            const _assetProfile = Object.assign({}, assetProfile);

            if (isDataObject<IPrivateCompany>(assetProfile.assetEntity)) {
                const assetEntity = Object.assign({}, assetProfile.assetEntity);
                _assetProfile.assetEntity = assetEntity.dobjId;
                assetEntities.push(assetEntity);
            }

            assetProfiles.push(_assetProfile);
        });

        if (assetProfiles.length > 0) {
            context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: assetProfiles });
        }
        if (assetEntities.length > 0) {
            void context.dispatch(`${PRIVATE_COMPANY_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: assetEntities }, { root: true });
        }
    }
};
